$(document).ready(function () {
    var searchForm = $('#SearchForm');
    var searchBtn = $('#SearchBtn');
    var search = $('#Search');

    var searchActive = false;

    search.on("input", function () {
        if (search.val() !== "") {
            search[0].setCustomValidity("");
        } else {
            search[0].setCustomValidity("No search given");
        }
    });

    searchBtn.click(function () {
        if ($(window).width() <= 640) {
            if (search.val() !== "" && searchForm[0].checkValidity()) {
                searchForm.submit();
            } else if (searchActive && search.val() === "") {
                searchActive = false;
                search[0].classList.remove('mobile-display');
                setTimeout(function () {
                    $('.d-none-search').css({ 'display': 'unset' });
                }, 300);
                searchBtn.removeClass('search-visible');
            } else if (!searchActive && search.val() === "") {
                searchActive = true;
                search.addClass('mobile-display');
                $('.d-none-search').css({ 'display': 'none' });
                searchBtn.addClass('search-visible');
            } else {
                search.addClass('mobile-display');
            }
        } else {
            searchForm.submit();
        }
    });

});